import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shield-fill",
  "use": "shield-fill-usage",
  "viewBox": "0 0 10 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 12\" id=\"shield-fill\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.708.694a1.58 1.58 0 01.585 0l3.497.659c.315.059.544.334.544.655v4.27c0 1.58-.81 3.048-2.146 3.886l-1.59.998c-.366.229-.83.229-1.195 0l-1.59-.998A4.586 4.586 0 01.667 6.279V2.008c0-.32.228-.596.543-.655L4.708.694z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol